<div class="app-layout" [class.sidebar-collapsed]="isSidebarCollapsed">
  <app-sidebar (collapsedChange)="onSidebarToggle($event)"></app-sidebar>
  <div class="main-area">
    <app-header></app-header>
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
